module.exports = __webpack_public_path__ + "img/administracion.5e0e3be0.svg";